<template>
<w-frame-popup-content-template>
  <div slot="content">
    <div class="title-bar title-h4">쪽지 보내기</div>
    <el-form :rules="rules" ref="messageForm" :model="messageFormData" label-width="120px" label-position="left">
      <el-row>
        <el-form-item label="내용" prop="messageContents">
          <el-input type="textarea" :rows="5" v-model="messageFormData.messageContents"></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="파일 등록">
          <el-upload :file-list="fileList" :auto-upload="false" :on-change="changeUploadFile" :show-file-list="false" :before-upload="(file) => file" action="">
            <el-button class="title-bar" size="mini" type="secondary">파일 업로드</el-button>
          </el-upload>
          <el-table :data="fileTableDatas" height="200px">
            <el-table-column prop="name" label="파일명" />
            <el-table-column label="삭제" width="60px">
              <template slot-scope="scope">
                <span class="c-pointer" @click="deleteFile(scope)"><i class="fal fa-times"></i></span>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="받는 사람" prop="managerList">
          <el-row type="flex" justify="end" class="title-bar">
            <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
          </el-row>
          <el-table-wrapper :data="managerList" :columns="tableColumn" height="200px" :column-default="columnDefault" header-align="center" ref="managerTable" :show-search-tool="showSearchTool" :show-custom-header="true" @selection-change="changeHandleSelection">
          </el-table-wrapper>
        </el-form-item>
      </el-row>
    </el-form>
  </div>
  <el-row slot="footer" type="flex" justify="center">
    <el-button type="solid" class="mr-r4" size="large" @click="sendMessage">저장</el-button>
    <el-button size="large" @click="cancelMessageForm">취소</el-button>
  </el-row>
</w-frame-popup-content-template>
</template>

<script>
import { findIndex, map, forEach, isNil } from 'lodash';
import mgrApi from '@/api/model/mgr';
import userApi from '@/api/frame/user';
import { DUPLICATE_MESSAGE, MSG_UPLOAD_UNAUTHORIZED_FILE } from '@/constants/file';
import msgUtil from '@/utils/message';
import { checkFileSize, isUnauthorizedFile } from '@/utils/file';
import { getDateToString } from '@/utils/date';
import { columnDefault } from '@/constants/table';
import WFramePopupContentTemplate from './FramePopupContentTemplate';

export default {
  name: 'WMessageForm',
  components: {
    WFramePopupContentTemplate,
  },
  props: {
    showMessageForm: {
      type: Boolean,
    },
    managerId: {
      type: String,
    },
  },
  data() {
    const messageContentsValidation = (rule, value, callback) => {
      if (value === '' || isNil(value)) {
        callback(new Error('내용을 입력해 주십시오.'));
      } else {
        callback();
      }
    };
    const managerListValidation = (rule, value, callback) => {
      if (this.selectedManager.length === 0) {
        return callback(new Error(' '));
      }
      return callback();
    };
    return {
      columnDefault,
      messageFormData: {},
      rules: {
        messageContents: [
          {
            required: true,
            validator: messageContentsValidation,
            trigger: 'blur',
          },
        ],
        managerList: [
          {
            required: true,
            validator: managerListValidation,
            trigger: 'blur',
          },
        ],
      },
      showSearchTool: false,
      tableColumn: [
        {
          align: 'center',
          type: 'selection',
          width: '50px',
        },
        {
          prop: 'managerId',
          label: '아이디',
          searchable: true,
        },
        {
          prop: 'managerName',
          label: '계정명',
          searchable: true,
        },
        {
          prop: 'department',
          label: '부서',
          searchable: true,
        },
        {
          prop: 'association',
          label: '소속',
          searchable: true,
        },
        {
          prop: 'grade',
          label: '직급',
          searchable: true,
        },
      ],
      managerList: [],
      fileList: [],
      fileTableDatas: [],
      senderId: null,
    };
  },
  watch: {
    showMessageForm: {
      handler(val) {
        if (val) {
          this.loadManagerList();
        }
      },
      immediate: true,
    },
  },
  methods: {
    initFormData(message) {
      if (isNil(message)) {
        this.messageFormData = {};
        this.fileList = [];
        this.fileTableDatas = [];
        this.selectedManager = [];
      } else {
        let replayContents = '---------------------------------------------------------------------------------------------\n';
        replayContents += `보낸 사람 : ${message.senderName}[${message.senderId}]\n`;
        replayContents += `받은 시간 : ${getDateToString(message.registDatetime)}\n`;
        replayContents += '---------------------------------------------------------------------------------------------\n';
        replayContents += `${message.messageContents}\n`;
        replayContents += '---------------------------------------------------------------------------------------------\n';
        this.$set(this.messageFormData, 'messageContents', replayContents);
        this.senderId = message.senderId;
      }
    },
    loadManagerList() {
      const params = {};
      mgrApi.getMgrList(params).then((response) => {
        if (response.data.success) {
          this.managerList = response.data.data;

          if (!isNil(this.senderId)) {
            const managerTable = this.$refs.managerTable.$children[0];
            this.$nextTick(() => {
              const index = findIndex(this.managerList, ['managerId', this.senderId]);
              managerTable.toggleRowSelection(this.managerList[index]);
            });
          }
        }
      });
    },
    changeUploadFile(item) {
      // 비인가 확장자 파일인 경우 업로드 불가능
      if (isUnauthorizedFile(item)) {
        this.$message(msgUtil.getCustomResultMsgData(MSG_UPLOAD_UNAUTHORIZED_FILE, false));
        return;
      }
      if (findIndex(this.fileTableDatas, ['name', item.raw.name]) > -1) {
        this.$message(msgUtil.getCustomMsgData(DUPLICATE_MESSAGE));
        return;
      }
      const result = checkFileSize(item.raw.size);
      if (result.enable !== true) {
        this.$message(msgUtil.getCustomMsgData(result.message));
        return;
      }
      this.fileTableDatas.push(item.raw);
      if (this.viewType === 'UPDATE') {
        this.checkChange.file = true;
        this.addFiles.push(item.raw);
      }
    },
    deleteFile(data) {
      this.fileTableDatas.splice(data.$index, 1);
    },
    changeHandleSelection(selectVal) {
      this.selectedManager = selectVal;
    },
    sendMessage() {
      const managerIds = map(this.selectedManager, 'managerId');

      const params = new FormData();
      forEach(this.fileTableDatas, (value, index) => {
        params.append(`file${index}`, value);
      });
      params.append('messageInfo', JSON.stringify(this.messageFormData));
      params.append('managerList', JSON.stringify(managerIds));

      this.$refs.messageForm.validate((valid, object) => {
        if (valid) {
          const action = '전송';
          const target = '쪽지';
          userApi
            .sendMessage(params)
            .then((response) => {
              if (response.data.success) {
                this.$message(msgUtil.getResultMsgData(action, target, true));
                this.$emit('load-data');
                if (managerIds.indexOf(this.managerId) > -1) {
                  this.$emit('update-count');
                }
                this.cancelMessageForm();
              } else {
                this.$message(msgUtil.getCustomResultMsgData(response.data.message, false));
              }
            })
            .catch(() => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            });
        } else if (!isNil(object.managerList)) {
          this.$message(msgUtil.getCustomMsgData('받는사람을 한 명 이상 선택해주십시오.'));
        } else {
          this.$message(msgUtil.getCustomMsgData('데이터를 확인해 주십시오.'));
        }
      });
    },
    cancelMessageForm() {
      this.$emit('cancel');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/frame/components/popup/MessageForm.vue